import { jsonldPerformerName } from './JsonldStore';

export const updateJsonldPerformerName = (value) => jsonldPerformerName.update((oldValue) => value);

